/**
 * ActivityTab Component
 *
 * Container for Activity sub-tabs (History and Statistics).
 * Manages sub-tab state and renders the appropriate view.
 */

import { useState, useEffect, type CSSProperties } from 'react';
import { ActivitySubTabs, type ActivityView } from './ActivitySubTabs';
import { HistoryView } from './HistoryView';
import { StatisticsView } from './StatisticsView';

interface ActivityTabProps {
  /** Initial view to display (default: 'history') */
  initialView?: ActivityView;
  /** Callback when view changes */
  onViewChange?: (view: ActivityView) => void;
}

/**
 * ActivityTab displays sub-tabs for History and Statistics views
 */
export function ActivityTab({ initialView = 'history', onViewChange }: ActivityTabProps) {
  const [activeView, setActiveView] = useState<ActivityView>(initialView);

  useEffect(() => {
    setActiveView(initialView);
  }, [initialView]);

  const handleViewChange = (view: ActivityView) => {
    setActiveView(view);
    onViewChange?.(view);
  };

  return (
    <div style={containerStyle}>
      <ActivitySubTabs activeView={activeView} onViewChange={handleViewChange} />
      <div style={contentStyle}>
        {activeView === 'history' && <HistoryView />}
        {activeView === 'statistics' && <StatisticsView />}
      </div>
    </div>
  );
}

const containerStyle: CSSProperties = {};

const contentStyle: CSSProperties = {};

export default ActivityTab;
